import { UserBonusCheckpointsV2RenderProps } from './props';
import styles from './styles.module.scss';
import { useMemo } from 'react';
import UserBonusCheckpointsV2RenderStep from './Step';

export default function UserBonusCheckpointsV2Render({
  checkpoints,
  userBonus,
  currentCheckpointIndex,
  isLoading,
}: UserBonusCheckpointsV2RenderProps) {
  const Steps = useMemo(
    () =>
      checkpoints?.map((checkpoint, index) => (
        <UserBonusCheckpointsV2RenderStep
          key={`transaction-step-${index}`}
          checkpoint={checkpoint}
          userBonus={userBonus}
          position={index}
          isCurrentCheckpoint={currentCheckpointIndex == index}
        />
      )),
    [checkpoints, userBonus, currentCheckpointIndex],
  );

  const Skeletons = useMemo(
    () =>
      Array.from({ length: 5 })?.map((_, index) => (
        <UserBonusCheckpointsV2RenderStep
          key={`transaction-step-${index}`}
          isLoading
        />
      )),
    [],
  );

  return (
    <div className={styles.container}>{isLoading ? Skeletons : Steps}</div>
  );
}
